import { render, staticRenderFns } from "./user-add.html?vue&type=template&id=2ae3d22d&scoped=true&external"
import script from "./user-add.js?vue&type=script&lang=js&external"
export * from "./user-add.js?vue&type=script&lang=js&external"
import style0 from "./user-add.scss?vue&type=style&index=0&id=2ae3d22d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae3d22d",
  null
  
)

export default component.exports